import React, { useState, useEffect, useRef } from "react"
import { withRouter } from "react-router-dom"
import { connect } from "react-redux"
import NotificationAlert from "react-notification-alert"

import firebaseConfig from "firebaseConfig"

import {
  Button,
  Container,
  Row,
  Col,
  Card,
  CardBody,
  CardTitle,
  CardImg,
  CardText,
} from "reactstrap"

import { Link } from "react-router-dom"

const COMMMUTE_TIME = "60"

class Schedule extends React.Component {
  state = {
    merchant: null,
    zipCode: null,
    package: null,
    addon: [],
    vehicleType: null,
    showAlert: false,
  }

  _getTotalMins() {
    let totalMins = 0
    totalMins += parseInt(COMMMUTE_TIME)
    const {
      package: pkg,
      addon,
      // vehicleType
    } = this.state
    if (pkg) {
      totalMins += parseInt(pkg.duration) || 0
    }
    if (addon && addon.length > 0) {
      addon.forEach((item) => (totalMins += parseInt(item.duration) || 0))
    }
    // if (vehicleType) {
    //   totalMins += parseInt(vehicleType.duration) || 0;
    // }
    return totalMins.toString()
  }

  _getTotalCost() {
    let totalCost = 0
    const {
      package: pkg,
      addon,
      // vehicleType
    } = this.state
    if (pkg) {
      totalCost += parseInt(pkg.cost) || 0
    }
    if (addon && addon.length > 0) {
      addon.forEach((item) => (totalCost += parseInt(item.cost) || 0))
    }
    // if (vehicleType) {
    //   totalCost += parseInt(vehicleType.cost) || 0;
    // }
    return totalCost.toString()
  }

  componentDidMount() {
    const props = { ...this.props }
    // console.log(JSON.stringify(props, null, 4));
    if (props && props.location) {
      if (props.location.state) {
        const pkg = props.location.state.package
        const vehicleType = props.location.state.vehicleType
        const { merchant, zipCode } = props.location.state
        if (pkg) {
          this.setState({ package: pkg })
        }

        if (vehicleType) {
          this.setState({ vehicleType })
        }

        if (merchant) {
          this.setState({ merchant })
        }

        if (zipCode) {
          this.setState({ zipCode })
        }
      } else {
        this._fetchMerchant()
      }
    }
  }

  _fetchMerchant() {
    const props = { ...this.props }
    if (props && props.match && props.match.params) {
      const { merchantId } = props.match.params
      if (merchantId) {
        firebaseConfig
          .firestore()
          .collection("merchants")
          // .doc(`${merchantId}`).get()
          .where("merchantId", "==", merchantId)
          .get()
          .then((snapshot) => {
            if (snapshot.size === 1) {
              snapshot.forEach((doc) => {
                this.setState({ merchant: { ...doc.data(), id: doc.id } })
              })
            }
          })
          .catch((err) =>
            console.log(`Error Fetching Merchant. Error:\n${err}`)
          )
      }
    }
  }

  _handlePackageClick(pkg) {
    if (pkg && pkg.cost) {
      this.setState({ package: pkg })
    }
  }

  _handleAddonClick(addon, doRemoveAddon, vehicleTypeTitle) {
    if (addon && addon.cost && vehicleTypeTitle) {
      // console.log(vehicleTypeTitle);
      if (!doRemoveAddon) {
        let { vehicleType } = this.state
        if (vehicleType) {
          let { selectedAddons } = vehicleType
          selectedAddons = selectedAddons || []
          vehicleType.selectedAddons = [...selectedAddons, addon]
        }
        this.setState({ vehicleType, addon: [...this.state.addon, addon] })
        // console.log(vehicleType);
      } else {
        const index = this.state.addon.indexOf(addon)
        const addonCopy = [...this.state.addon]
        addonCopy.splice(index, 1)
        let { vehicleType } = this.state
        if (vehicleType) {
          let { selectedAddons } = vehicleType
          selectedAddons = selectedAddons || []
          if (selectedAddons && selectedAddons.length > 0) {
            const index = selectedAddons.indexOf(addon)
            const selectedAddonsCopy = [...selectedAddons]
            selectedAddonsCopy.splice(index, 1)
            vehicleType.selectedAddons = selectedAddonsCopy
          }
        }
        this.setState({ vehicleType, addon: addonCopy })
      }
    }
  }

  _handleVehicleTypeClick(vType, doRemoveAddon) {
    // console.log('doRemoveAddOn', doRemoveAddon);
    if (vType && vType.title) {
      // vehicleType Should Have Title
      if (!doRemoveAddon) {
        this.setState({ vehicleType: vType })
      } else {
        // console.log('Resetting - addon in _handleVehicleTypeClick');
        const vTypeCopy = { ...vType }
        vTypeCopy.selectedAddons = []
        this.setState({ addon: [], package: null, vehicleType: vTypeCopy })
      }
    }
  }

  notify = (type, message, title) => {
    let options = {
      place: "tc",
      message: (
        <div className="alert-text">
          <span className="alert-title" data-notify="title">
            {" "}
            {title}
          </span>
          <span data-notify="message">{message}</span>
        </div>
      ),
      type: type,
      icon: "ni ni-bell-55",
      autoDismiss: 5,
    }
    this.refs.notificationAlert.notificationAlert(options)
  }

  render() {
    const { merchant, zipCode } = this.state
    const totalCost = this._getTotalCost()
    // const totalMins = this._getTotalMins();
    // console.log(JSON.stringify({ addon: this.state.addon, vehicleType: this.state.vehicleType }, null, 4));
    return (
      <>
        <div className="rna-wrapper">
          <NotificationAlert ref="notificationAlert" />
        </div>
        {merchant && (
          <div className="header pt-4 pb-4 flex-wrapper">
            <Container className="chift-container-lg">
              <div className="merchant-header mb-2 chift-merchant-header-image">
                <CardImg
                  alt="..."
                  src={
                    merchant.logo ||
                    require("assets/img/theme/light-grey-bg.png")
                  }
                  top
                />
              </div>
              <div className="merchant-body">
                <Row className="align-items-center">
                  <Col lg="9">
                    <div className="pr-5">
                      <h4 className="display-4 font-weight-bold mb-0 text-left">
                        {merchant.title || merchant.name}
                      </h4>
                    </div>
                  </Col>
                  <Col lg="3" className="text-right">
                    <div>
                      <span className="display-6 mb-0 text-right">
                        4.7
                        <i className="fa fa-star" aria-hidden="true"></i>
                        <i className="fa fa-star" aria-hidden="true"></i>
                        <i className="fa fa-star" aria-hidden="true"></i>
                        <i className="fa fa-star" aria-hidden="true"></i>
                        <i className="fa fa-star" aria-hidden="true"></i>
                      </span>
                    </div>
                  </Col>
                </Row>
                {/* <MerchantPackages
                    packageViaProp={this.state.package}
                    packages={merchant.packages}
                    handlePackageClick={this._handlePackageClick.bind(this)}
                  /> */}
                {/* {
                    merchant.packages && merchant.packages.length > 0 &&
                      <MerchantAddon
                        addons={(merchant.addon && merchant.addon.length > 0) ? merchant.addon : merchant.addons}
                        handleAddonClick={this._handleAddonClick.bind(this)}
                      />
                  } */}
                {merchant.vehicleType && merchant.vehicleType.length > 0 && (
                  <MerchantVehicleType
                    vehicleTypeViaProp={this.state.vehicleType}
                    vehicleType={merchant.vehicleType}
                    handleVehicleTypeClick={this._handleVehicleTypeClick.bind(
                      this
                    )}
                    handleAddonClick={this._handleAddonClick.bind(this)}
                    handlePackageClick={this._handlePackageClick.bind(this)}
                  />
                )}
                <Row>
                  <Col lg="12" className="text-center">
                    {this.state.package && this.state.vehicleType ? (
                      <Link
                        to={{
                          pathname: `/merchant/${merchant.merchantId}/schedule`,
                          state: {
                            merchant,
                            selectedItems: {
                              package: this.state.package,
                              vehicleType: this.state.vehicleType,
                              addon: this.state.addon,
                            },
                            zipCode,
                            orderDuration: this._getTotalMins(),
                          },
                        }}
                      >
                        <Button color="primary">
                          Next {"($" + totalCost + ")"}{" "}
                          {/* <small>{totalMins + 'Min'}</small> */}
                        </Button>
                      </Link>
                    ) : (
                      <Button
                        color="primary"
                        onClick={() => {
                          this.notify(
                            "danger",
                            "Please Select All Options",
                            "Warning"
                          )
                        }}
                      >
                        Next {"($" + totalCost + ")"}{" "}
                        {/* <small>{totalMins + 'Min'}</small> */}
                      </Button>
                    )}
                  </Col>
                </Row>
              </div>
            </Container>
          </div>
        )}
      </>
    )
  }
}

function MerchantPackages({
  packageViaProp,
  vehicleTypeTitle,
  packages,
  handlePackageClick,
}) {
  const [selectedPackage, setSelectedPackage] = useState(null)

  // scrollLeft(element, change, duration) {
  //
  //     element.scrollLeft = 150
  //       // var start = element.scrollLeft,
  //       //     currentTime = 0,
  //       //     increment = 20;
  //       //
  //       //     console.log(start)
  //       //
  //       // var animateScroll = function(){
  //       //     currentTime += increment;
  //       //     var val = Math.easeInOutQuad(currentTime, start, change, duration);
  //       //     element.scrollLeft = val;
  //       //     if(currentTime < duration) {
  //       //         setTimeout(animateScroll, increment);
  //       //     }
  //       // };
  //       // animateScroll();
  //   }

  useEffect(() => {
    if (packageViaProp && !selectedPackage) {
      setSelectedPackage(packageViaProp.title)
    }
  }, [packageViaProp, selectedPackage])
  const prevVehicleTypeTitleRef = useRef()
  useEffect(() => {
    prevVehicleTypeTitleRef.current = vehicleTypeTitle
  }, [vehicleTypeTitle])
  const prevVehicleTypeTitle = prevVehicleTypeTitleRef.current
  useEffect(() => {
    if (
      vehicleTypeTitle &&
      prevVehicleTypeTitle &&
      vehicleTypeTitle !== prevVehicleTypeTitle
    ) {
      // console.log('Resetting - MerchantAddon');
      setSelectedPackage(null)
    }
  }, [vehicleTypeTitle, prevVehicleTypeTitle])
  if (packages && packages.length > 0) {
    return (
      <>
        <SectionHeading title={`Select Package - ${vehicleTypeTitle}`} />
        <Row className="selectType">
          {/*<div className="scroll_arrows">
              <button id="left-button1" className="arrow_left arrow-hidden" onClick={()=> {document.getElementById('content').scrollLeft -= 200}}>
              <img alt="..." src={require("assets/img/theme/left-arrow.png")} />
              </button>
              <button id="right-button1" className="arrow_right" onClick={() => {document.getElementById("left-button1").classList.remove('arrow-hidden');document.getElementById('content').scrollLeft += 200}}>
              <img alt="..." src={require("assets/img/theme/right-arrow.png")} />
              </button>
          </div>*/}
          <div
            className="d-flex flex-row flex-nowrap scrolling-wrapper-flexbox"
            id="content"
          >
            {packages.map((pkg, idx) => {
              const backgroundColor =
                selectedPackage === pkg.title ? "#eaf8ff" : ""
              const border =
                selectedPackage === pkg.title ? "1px solid #3262A0" : ""
              return (
                <Col lg="3" key={idx}>
                  <Card
                    className={
                      selectedPackage === pkg.title
                        ? "shadow-lg chift-scroll-card chift-package"
                        : "chift-scroll-card chift-package"
                    }
                    style={{
                      cursor: "pointer",
                      backgroundColor,
                      border,
                    }}
                    onClick={() => {
                      // console.log('Package-Clicked');
                      handlePackageClick(pkg)
                      setSelectedPackage(pkg.title)
                    }}
                  >
                    <CardBody>
                      <CardTitle className="mb-3" tag="h3">
                        {pkg.title}{" "}
                        <span className="text-muted">{"$" + pkg.cost}</span>
                        <br />
                        <small className="text-muted">
                          {pkg.duration + "Min"}
                        </small>
                      </CardTitle>
                      <CardText className="mb-2 chift-card-text">
                        {pkg.shortDescription}
                      </CardText>
                    </CardBody>
                  </Card>
                </Col>
              )
            })}
          </div>
        </Row>
      </>
    )
  }
  return <p>Sucks! No Packages Available.</p>
}

function MerchantAddon({ addon, vehicleTypeTitle, handleAddonClick }) {
  const [selectedAddons, setSelectedAddons] = useState([])
  const prevVehicleTypeTitleRef = useRef()
  useEffect(() => {
    prevVehicleTypeTitleRef.current = vehicleTypeTitle
  }, [vehicleTypeTitle])
  const prevVehicleTypeTitle = prevVehicleTypeTitleRef.current
  useEffect(() => {
    if (
      vehicleTypeTitle &&
      prevVehicleTypeTitle &&
      vehicleTypeTitle !== prevVehicleTypeTitle
    ) {
      // console.log('Resetting - MerchantAddon');
      setSelectedAddons([])
    }
  }, [vehicleTypeTitle, prevVehicleTypeTitle])
  // console.log(vehicleTypeTitle, prevVehicleTypeTitle);
  // console.log(JSON.stringify(['MerchantAddon', addon], null, 4));
  // console.log(JSON.stringify(['MerchantAddon', ...selectedAddons], null, 4));
  if (addon && addon.length > 0) {
    return (
      <>
        <SectionHeading
          title={`Add-Ons (Select Any That Apply) - ${vehicleTypeTitle}`}
        />
        <Row className="selectType selectType_sm">
          {/*<div className="scroll_arrows">
            <button id="left-button2" className="arrow_left arrow-hidden" onClick={()=> {document.getElementById('content-addon').scrollLeft -= 200}}>
            <img alt="..." src={require("assets/img/theme/left-arrow.png")} />
            </button>
            <button id="right-button2" className="arrow_right" onClick={() => {document.getElementById("left-button2").classList.remove('arrow-hidden');document.getElementById('content-addon').scrollLeft += 200}}>
            <img alt="..." src={require("assets/img/theme/right-arrow.png")} />
            </button>
          </div>*/}
          <div
            className="d-flex flex-row flex-nowrap scrolling-wrapper-flexbox"
            id="content-addon"
          >
            {addon.map((item, idx) => {
              let backgroundColor = ""
              let border = ""
              if (selectedAddons && selectedAddons.indexOf(item.title) > -1) {
                backgroundColor = "#eaf8ff"
                border = "1px solid #3262A0"
              }
              return (
                <Col lg="3" key={idx}>
                  <Card
                    className={
                      selectedAddons && selectedAddons.indexOf(item.title) > -1
                        ? "shadow-lg chift-scroll-card"
                        : "chift-scroll-card"
                    }
                    style={{
                      cursor: "pointer",
                      backgroundColor,
                      border,
                    }}
                    onClick={() => {
                      if (!(selectedAddons.indexOf(item.title) > -1)) {
                        const doRemoveAddon = false
                        handleAddonClick(item, doRemoveAddon, vehicleTypeTitle)
                        setSelectedAddons([...selectedAddons, item.title])
                      } else {
                        const doRemoveAddon = true
                        handleAddonClick(item, doRemoveAddon, vehicleTypeTitle)

                        const index = selectedAddons.indexOf(item.title)
                        const selectedAddonsCopy = [...selectedAddons]
                        selectedAddonsCopy.splice(index, 1)
                        setSelectedAddons(selectedAddonsCopy)
                      }
                    }}
                  >
                    <CardBody>
                      <Row className="align-items-center">
                        <Col className="col-auto">
                          <a
                            className="avatar avatar-sm rounded-circle addon-img"
                            href="#fa"
                            onClick={(e) => e.preventDefault()}
                          >
                            <img alt="..." src="/img/add.png" />
                          </a>
                        </Col>
                        <div className="col ml--2">
                          <h4 className="mb-0">
                            <a href="#fa" onClick={(e) => e.preventDefault()}>
                              {/* {item.title} <br /> ${item.cost} */}
                              {item.title}{" "}
                              <span
                                className="text-muted"
                                style={{ fontWeight: "bold" }}
                              >
                                ${item.cost}
                              </span>
                              <br />
                              {item.duration ? (
                                <small className="text-muted">
                                  {item.duration + "Min"}
                                </small>
                              ) : null}
                            </a>
                          </h4>
                        </div>
                        {/* <Col className="col-auto">
                          <div>
                            <div className="custom-control custom-checkbox" >
                              <input
                                className="custom-control-input"
                                id={`chk-todo-task-4-${idx}`}
                                type="checkbox"
                                onClick={() => {
                                  if (!(selectedAddons.indexOf(item.title) > -1)) {
                                    handleAddonClick(item);
                                    setSelectedAddons([...selectedAddons, item.title]);
                                  } else {
                                    const doRemoveAddon = true;
                                    handleAddonClick(item, doRemoveAddon);

                                    const index = selectedAddons.indexOf(item.title);
                                    const selectedAddonsCopy = [...selectedAddons];
                                    selectedAddonsCopy.splice(index, 1);
                                    setSelectedAddons(selectedAddonsCopy);
                                  }
                                }}
                              />
                              <label
                                className="custom-control-label"
                                htmlFor={`chk-todo-task-4-${idx}`}
                              />
                            </div>
                          </div>
                        </Col> */}
                      </Row>
                    </CardBody>
                  </Card>
                </Col>
              )
            })}
          </div>
        </Row>
      </>
    )
  }
  return null
}

function MerchantVehicleType({
  vehicleTypeViaProp,
  vehicleType,
  handleVehicleTypeClick,
  handleAddonClick,
  handlePackageClick,
}) {
  const [packages, setPackages] = useState(null)
  const [addon, setAddon] = useState(null)
  const [selectedVehicleType, setSelectedVehicleType] = useState(null)
  useEffect(() => {
    if (vehicleTypeViaProp && !selectedVehicleType) {
      setSelectedVehicleType(vehicleTypeViaProp.title)
      setAddon(vehicleTypeViaProp.addon)
      setPackages(vehicleTypeViaProp.packages)
    }
  }, [vehicleTypeViaProp, selectedVehicleType])
  const prevSelectedVehicleTypeRef = useRef()
  useEffect(() => {
    prevSelectedVehicleTypeRef.current = selectedVehicleType
  }, [selectedVehicleType])
  const prevSelectedVehicleType = prevSelectedVehicleTypeRef.current
  // console.log(selectedVehicleType, prevSelectedVehicleType);
  // console.log(addon);
  if (vehicleType && vehicleType.length > 0) {
    return (
      <>
        <SectionHeading title="Select Vehicle Type (Required)" />
        <Row className="selectType selectType_sm">
          {/*<div className="scroll_arrows">
            <button id="left-button3" className="arrow_left arrow-hidden" onClick={()=> {document.getElementById('content-vehicleType').scrollLeft -= 200}}>
            <img alt="..." src={require("assets/img/theme/left-arrow.png")} />
            </button>
            <button id="right-button3" className="arrow_right" onClick={() => {document.getElementById("left-button3").classList.remove('arrow-hidden');document.getElementById('content-vehicleType').scrollLeft += 200}}>
            <img alt="..." src={require("assets/img/theme/right-arrow.png")} />
            </button>
          </div>*/}
          <div
            className="d-flex flex-row flex-nowrap scrolling-wrapper-flexbox"
            id="content-vehicleType"
          >
            {vehicleType.map((vType, idx) => {
              const backgroundColor =
                selectedVehicleType === vType.title ? "#eaf8ff" : ""
              const border =
                selectedVehicleType === vType.title ? "1px solid #3262A0" : ""
              return (
                <Col lg="3" key={idx}>
                  <Card
                    className={
                      selectedVehicleType === vType.title
                        ? "shadow-lg chift-scroll-card"
                        : "chift-scroll-card"
                    }
                    style={{
                      cursor: "pointer",
                      backgroundColor,
                      border,
                    }}
                    onClick={() => {
                      // console.log(vType.addon);
                      // console.log(selectedVehicleType, prevSelectedVehicleType);
                      // const doRemoveAddon = (selectedVehicleType && prevSelectedVehicleType === null) || (selectedVehicleType && prevSelectedVehicleType && selectedVehicleType !== prevSelectedVehicleType);
                      const doRemoveAddon =
                        selectedVehicleType === prevSelectedVehicleType
                      handleVehicleTypeClick(vType, doRemoveAddon)
                      setSelectedVehicleType(vType.title)
                      setAddon(vType.addon)
                      setPackages(vType.packages)
                    }}
                  >
                    <CardBody>
                      <Row className="align-items-center">
                        <Col className="col-auto">
                          <a
                            className="avatar avatar-md rounded-rectangle vehicleTypeIcon"
                            href="#fa"
                            onClick={(e) => e.preventDefault()}
                          >
                            <img
                              alt="..."
                              src={
                                vType.icon ||
                                require("assets/img/theme/light-grey-bg.png")
                              }
                            />
                          </a>
                        </Col>
                        <div className="col ml--2">
                          <h4 className="mb-0">
                            <a href="#fa" onClick={(e) => e.preventDefault()}>
                              {/* {vType.title} <br /> ${vType.cost} */}
                              {vType.title} <br />
                              {/* <small className='text-muted'>{vType.duration + 'Min' }</small> */}
                            </a>
                          </h4>
                        </div>
                        {/* <Col className="col-auto">
                          <div className="custom-control custom-radio">
                            <input
                              className="custom-control-input"
                              id={`customRadio5-${idx}`}
                              name="custom-radio-1"
                              type="radio"
                              onClick={() => {
                                handleVehicleTypeClick(vType);
                                setSelectedVehicleType(vType.title);
                              }}
                            />
                            <label
                              className="custom-control-label"
                              htmlFor={`customRadio5-${idx}`}
                            />
                          </div>
                        </Col> */}
                      </Row>
                    </CardBody>
                  </Card>
                </Col>
              )
            })}
          </div>
        </Row>
        {packages && packages.length > 0 ? (
          <MerchantPackages
            vehicleTypeTitle={selectedVehicleType}
            packages={packages}
            handlePackageClick={handlePackageClick}
          />
        ) : null}
        {addon && addon.length > 0 ? (
          <MerchantAddon
            vehicleTypeTitle={selectedVehicleType}
            addon={addon}
            handleAddonClick={handleAddonClick}
          />
        ) : null}
      </>
    )
  }
  return null
}

function SectionHeading({ title }) {
  return (
    <Row className="align-items-center">
      <Col lg="12">
        <div className="pr-5">
          <h4 className="display-5 font-weight-bold mb-4 mt-2 text-left text-primary">
            {title}
          </h4>
        </div>
      </Col>
    </Row>
  )
}

const mapStateToProps = () => {
  return {}
}

export default connect(mapStateToProps, {})(withRouter(Schedule))
